const policyCancellationStatus = {
    INVALID : 0,

    REQUESTED : 1,

    PENDING : 2,

    CANCELLED : 3,

    RETRACTED : 4,

    RESCINDED : 5

};

angular.module('gw-um-j2js')
    .constant('policyCancellationStatus', policyCancellationStatus);